module.exports = __webpack_public_path__ + "static/media/paso-2.3790c1b6.png";